/* SPOILT — product description
   Renders the product description with its paragraphs / line breaks / lists
   and adds a Read more / Read less toggle. */
(function () {
  'use strict';

  function sanitize(html) {
    var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');

    Array.prototype.slice
      .call(doc.querySelectorAll('script,style,iframe,object,embed,link,meta,form'))
      .forEach(function (node) {
        node.parentNode.removeChild(node);
      });

    Array.prototype.slice.call(doc.body.querySelectorAll('*')).forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        var name = attr.name.toLowerCase();
        var value = String(attr.value).replace(/\s+/g, '').toLowerCase();

        if (
          name.indexOf('on') === 0 ||
          name === 'style' ||
          name === 'class' ||
          name === 'id' ||
          name === 'color' ||
          name === 'face' ||
          name === 'size' ||
          ((name === 'href' || name === 'src') && value.indexOf('javascript:') === 0)
        ) {
          el.removeAttribute(attr.name);
        }
      });

      if (el.tagName === 'A') {
        el.setAttribute('rel', 'noopener');
      }
    });

    return doc.body.innerHTML;
  }

  function init() {
    var sub = document.querySelector('.spoilt-product-root .spoilt-subtitle');
    var dataEl = document.getElementById('SpoiltDescriptionData');
    if (!sub || !dataEl || sub.getAttribute('data-desc-ready')) return;

    var html;
    try {
      html = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    if (typeof html !== 'string' || !html.trim()) return;

    /* Plain-text descriptions: keep their line breaks. */
    if (!/<(p|br|ul|ol|li|div|h[1-6]|table|blockquote)[\s>\/]/i.test(html)) {
      html = html.replace(/\r?\n/g, '<br>');
    }

    var clean = sanitize(html);
    if (!clean.trim()) return;

    var wrap = document.createElement('div');
    wrap.className = 'spoilt-desc';
    wrap.setAttribute('data-desc-ready', 'true');

    var body = document.createElement('div');
    body.className = 'spoilt-desc-body';
    body.id = 'SpoiltDescBody';
    body.innerHTML = clean;
    wrap.appendChild(body);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'spoilt-desc-toggle';
    button.textContent = 'Read more';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'SpoiltDescBody');
    button.hidden = true;
    wrap.appendChild(button);

    sub.parentNode.replaceChild(wrap, sub);

    var expanded = false;

    function measure() {
      if (expanded) return;
      wrap.classList.add('is-collapsed');
      var overflowing = body.scrollHeight > body.clientHeight + 2;
      if (overflowing) {
        button.hidden = false;
      } else {
        wrap.classList.remove('is-collapsed');
        button.hidden = true;
      }
    }

    button.addEventListener('click', function () {
      expanded = !expanded;
      wrap.classList.toggle('is-collapsed', !expanded);
      button.textContent = expanded ? 'Read less' : 'Read more';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
